module.exports = __webpack_public_path__ + "static/media/default_coverimage.9d060499.svg";